/**
 * Gruppiert einzelne ScAnswerElemente
 * Stellt den einzlnen ScAnswerElementen Controller methoden zu Verfügung
 * @class directive_v3sScAnswerGroupDirective
 */
angular.module('v3sWbtPlayerApp').directive('v3sScAnswerGroup', function () {
    return {
        restrict: 'E',
        controller: ["$scope", function ($scope) {

            $scope.answer = { id: '' };
            var answerElements = [];

            this.bindAnswerId = function (scope) {
                scope.answer = $scope.answer;
            }

            this.addAnswer = function (answerElement) {
                answerElements.push(answerElement);
            }

            $scope.$watch('answer.id', function () {
                if (!!$scope.answer.id) {
                    var selectedAnswerElement = null;
                    angular.forEach(answerElements, function (answerElement) {
                        //Falls das AnswerElement schon completed ist, muss nichts geändert werden
                        if (!answerElement.completed) {
                            if ($scope.answer.id === answerElement.id) {
                                selectedAnswerElement = answerElement;
                            } else {
                                answerElement.setUserAnswer(false);
                                answerElement.showFeedback(false);
                            }
                        }
                    });
                    if(selectedAnswerElement) selectedAnswerElement.setUserAnswer(true);
                }
            });

        }],
        link: function (scope, element, attrs) {
        }
    }
});
